export default __webpack_public_path__ + "static/media/azure-certified-solutions-architect.9efb2130.png";